import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Grid } from "@mui/material";
import { icons } from "../../../constants";

const ExpandableTable = ({
  data = [],
  columns = [],
  actionButtons = () => null,
  globalFilterFields = []
}) => {
  const [expandedRows, setExpandedRows] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");

  const lowerFilter = globalFilter.toLowerCase();

  const filterMatch = (obj, fields) =>
    fields.some((field) => {
      const keys = field.split(".");
      let value = obj;
      for (const key of keys) {
        value = value?.[key];
        if (!value) return false;
      }
      return String(value).toLowerCase().includes(lowerFilter);
    });

  const flatData = data.flatMap((supplier) => {
    const isExpanded = expandedRows.includes(supplier.id);
    const parentMatch = filterMatch(supplier, globalFilterFields);
    const matchingChildren = (supplier.productos || []).filter((product) =>
      filterMatch(product, globalFilterFields)
    );

    // Si no hay filtro, render normal
    if (!globalFilter) {
      const parentRow = {
        ...supplier,
        rowType: "parent",
        isExpanded,
        id: supplier.id
      };

      const childRows = isExpanded
        ? (supplier.productos || []).map((product) => ({
            ...product,
            rowType: "child",
            tableId: `${supplier.id}-${product.id}`,
            parentId: supplier.id,
            childId: product.id
          }))
        : [];

      return [parentRow, ...childRows];
    }

    // Si el proveedor hace match con el filtro
    if (parentMatch) {
      const parentRow = {
        ...supplier,
        rowType: "parent",
        isExpanded: true,
        id: supplier.id
      };

      const childRows = (supplier.productos || []).map((product) => ({
        ...product,
        rowType: "child",
        tableId: `${supplier.id}-${product.id}`,
        parentId: supplier.id,
        childId: product.id
      }));

      return [parentRow, ...childRows];
    }

    // Si algún producto hace match, mostrarlo expandido pero solo los hijos filtrados
    if (matchingChildren.length > 0) {
      const parentRow = {
        ...supplier,
        rowType: "parent",
        isExpanded: true,
        id: supplier.id
      };

      const childRows = matchingChildren.map((product) => ({
        ...product,
        rowType: "child",
        tableId: `${supplier.id}-${product.id}`,
        parentId: supplier.id,
        childId: product.id
      }));

      return [parentRow, ...childRows];
    }

    // Si nada coincide, no renderizar
    return [];
  });

  const toggleRow = (rowId) => {
    setExpandedRows((prev) =>
      prev.includes(rowId)
        ? prev.filter((id) => id !== rowId)
        : [...prev, rowId]
    );
  };

  const expanderTemplate = (rowData) =>
    rowData.rowType === "parent" ? (
      <Button
        icon={rowData.isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className="p-button-text p-button-sm"
        onClick={() => toggleRow(rowData.id)}
      />
    ) : null;

  const actionTemplate = (rowData) => actionButtons(rowData, rowData.rowType);

  const header = globalFilterFields.length > 0 && (
    <Grid container spacing={1.3}>
      <Grid item xs={12} md={6}>
        <div className="p-inputgroup">
          <span className="p-inputgroup-addon custom-input-search-icon">
            <img className="btn-icon" src={icons.lupablue} alt="icon" />
          </span>
          <InputText
            className="custom-input-search"
            placeholder="Buscar..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
        </div>
      </Grid>
    </Grid>
  );

  return (
    <div className="card">
      <DataTable
        value={flatData}
        dataKey={(row) =>
          row.rowType === "child" ? row.tableId : `parent-${row.id}`
        }
        responsiveLayout="scroll"
        header={header}
        rowClassName={(row) => (row.rowType === "child" ? "child-row" : "")}
      >
        <Column body={expanderTemplate} style={{ width: "3rem" }} />
        {columns.map((col) => (
          <Column
            key={col.field}
            field={col.field}
            header={col.header}
            style={{ width: col.columnWidth || col.width || "auto" }}
            body={
              col.columnType === "custom" && col.render ? col.render : undefined
            }
          />
        ))}
        <Column
  header="Acciones"
  body={actionTemplate}
  style={{
    width: "8rem",
    textAlign: "center",
    position: "sticky",
    right: 0,
    background: "#6a6ad8a6",
    zIndex: 2
  }}
  headerStyle={{
    position: "sticky",
    right: 0,
    background: "#4444b2",
    zIndex: 3
  }}
  bodyStyle={{
    position: "sticky",
    right: 0,
    background: "#fff",
    zIndex: 2
  }}
/>
      </DataTable>
    </div>
  );
};

export default ExpandableTable;
